<div
  [class.highlight]="highlighted()"
  [style.animation-delay]="(this.itemIndex() * 800) + 'ms'"
  class="flex items-center gap-2 py-1.5 font-medium rounded text-xs text-[var(--p-surface-600)]  {{isDone() ? 'bg-emerald-50' : ''}}   border-t border-[var(--p-surface-200)]">
  <p-checkbox (click)="$event.stopPropagation()" (onChange)="toggleCompletion()" [binary]="true"
              [formControl]="completionControl"/>
  <span class="line-clamp-1 flex-1">{{ subTodo().title || '—' }}</span>
  @if (subTodo().dueDate) {
    <elcia-tooltip [tooltip]="subTodo().dueDate | dueDateFull">


    <span [class]="subTodo().dueDate | dueDateClass" class="shrink-0 text-xs">
          {{ subTodo().dueDate | dueDateFormat }}
    </span>
    </elcia-tooltip>
  }
  @if (subTodo().assignees.length) {
    <span>
      <elcia-avatar [avatars]="subTodo().assignees" [maxItem]="1"/>
    </span>
  }
</div>
